import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SecondaryButton } from 'common/components';
import { ReactComponent as CloseIcon } from 'application/assets/close.svg';
import { ReactComponent as SuccessIcon } from 'application/assets/success-icon.svg';
import { StyledModal } from './styles';
import { Modal } from '@mui/material';

interface SuccessModalProps {
  typeName: string;
  onClose: () => void;
}

const SuccessModal: FC<SuccessModalProps> = ({ typeName, onClose }) => {
  const { t } = useTranslation();
  return (
    <Modal open={true}>
      <StyledModal>
        <CloseIcon onClick={onClose} />
        <div>
          <SuccessIcon />
          <p>{typeName}</p>
          <SecondaryButton onClick={onClose}>
            {t('modal_success.ok')}
          </SecondaryButton>
        </div>
      </StyledModal>
    </Modal>
  );
};

export default SuccessModal;
